import Axios from "axios";
import { action, decorate, observable } from "mobx";
import LocalGridConfig from "../../../../config/LocalGridConfig";
import { isActiveStatus, isFinilized } from "../../../../utils/GlobalFunction";

export default class ManageDeliveryChargeStore {
	agGrid = null;
	per_page = LocalGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	editValues = null;
	deleteValues = null;
	viewValues = null;
	statusValues = null;
	total = 0;
	allColumnIds = [];
	formField = null;
	activeList = 1;
	dropdown_delivery_chrg_list = null;
	
	setActiveList = (status) => {
		this.activeList = status;
	}

	setAddMoreValues = (data) => {
		this.formField = data;
	}

	setViewValues = (data) => {
		this.viewValues = data;
	};

	setEditValues = (data) => {
		this.editValues = data;
	};

	setDeleteValues = (data) => {
		this.deleteValues = data;
	};

	setStatusValues = (data) => {
		this.statusValues = data;
	};

	setupGrid = (params) => {
		this.agGrid = params;
	};

	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	getList = (payload) => {
		if (this.agGrid) {
			var filter = this.agGrid.api.getFilterModel();
			var sort = this.agGrid.api.getSortModel();
		}
		this.list_data = null;
		if (payload) {
			payload.is_active = this.activeList;
		} else {
			payload = {};
			payload.is_active = this.activeList;
		}
		return Axios.post(`business/delivery-charge-templates/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				data.list.data.map((item, index) => {
					item.srno = index + 1;
					item.is_active_display =
						item.is_active === 1 ? isActiveStatus[1] : isActiveStatus[0];
					item.is_draft_display = item.is_draft === 1 ? isFinilized[1] : isFinilized[0];
					return null;
				});
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			var allColumnIds = [];
			if (this.agGrid && this.agGrid.columnApi) {
				this.agGrid.columnApi.getAllColumns().forEach(function (column) {
					allColumnIds.push(column.colId);
				});
			}
			if (this.agGrid) {
				this.agGrid.api.setFilterModel(filter);
				this.agGrid.api.setSortModel(sort);
			}
		});
	};

	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	getPreRequestData = () => {
		return Axios.get(`business/delivery-charge-templates/pre-create`).then(({ data }) => {
			this.setAddMoreValues(data.view);
			return data;
		});
	};

	AddData = (formData) => {
		return Axios.post(`business/delivery-charge-templates/new`, formData)
			.then(({ data }) => {
				this.getList();
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	EditData = (formData) => {
		return Axios.post(`business/delivery-charge-templates/edit/` + formData.id, formData)
			.then(({ data }) => {
				this.getList();
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	DeleteData = (formData) => {
		return Axios.delete(`business/delivery-charge-templates/destroy/` + formData.id)
			.then(({ data }) => {
				this.getList();
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	TogglePublishData = (formData) => {
		const apiPrefix = formData.is_active === 1 ? "deactivate/" : "activate/";
		return Axios.patch("business/delivery-charge-templates/" + apiPrefix + formData.id)
			.then(({ data }) => {
				this.getList();
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	FinalizeTemplate = (formData) => {
		return Axios.patch("business/delivery-charge-templates/finalize/" + formData.id)
			.then(({ data }) => {
				this.getList();
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ViewData = (formData) => {
		return Axios.post(`/business/delivery-charge-templates/details`, formData).then(({ data }) => {
			this.setViewValues(data.view);
			this.setEditValues(data.view);
			this.setAddMoreValues(data.pre_create);
			return data;
		});
	};

	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	CopyTemplateData = (formData) => {
		return Axios.post(`business/delivery-charge-templates/rates-template-copy`, formData)
			.then(({ data }) => {
				this.getList();
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	PrintTemplate = (formData) => {
		return Axios.post(`business/delivery-charge-templates/print`, formData)
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	getDeliveryChrgTemplateList = (conditional = {}) => {
		return Axios.post(`business/delivery-charge-templates/lov`, conditional)
			.then(({ data }) => {
				this.dropdown_delivery_chrg_list = data.delivery_chrg
				return data
			})
			.catch((response) => {
				return Promise.reject(response);
			})
	}
}

decorate(ManageDeliveryChargeStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	editValues: observable,
	deleteValues: observable,
	statusValues: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	setEditValues: action,
	setDeleteValues: action,
	setStatusValues: action,
	getList: action,
	onFilterChanged: action,
	setViewValues: action,
	viewValues: observable,
	formField: observable,
	activeList: observable,
	dropdown_delivery_chrg_list: observable
});
